import http from '@/utils/http/index'
import state from '@/utils/tools/state'

// 订单信息
export function getOrderInfo(id) {
  return http.get(`/checkout/information/${id}`)
}

// 确认支付
export function confirm(id, data) {
  return http.post(`/checkout/confirm/${id}`, data)
}

// 保存操作信息
export function postRecordEvents(data) {
  const url =
    process.env.NODE_ENV === 'development' ? '/webhook/merchant/cashier/record/add' : '/webhook/api/merchant/cashier/record/add'
  navigator.sendBeacon(url, data)
  sessionStorage.clear()
}

// Test record events
export function postTestRecordEvents() {
  http.get('/webhook/merchant/cashier/record/get').then((res) => {
    console.log(res)
  })
}

// Test Payment
export function postPaymentLogger(params, id, action) {
  // const url =
  //   process.env.NODE_ENV === 'development' ?  : `/checkout/logger/${id}?action=${action}`
  http.post(`/checkout/logger/${id}?action=${action}`, params).then((res) => {})
}

// 获取省列表
export function getStateList(country2) {
  return Promise.resolve(state[country2] || null)
}

// 订单状态
export function getOrderStatus(id) {
  return http.get(`/checkout/result/${id}`)
}

// 创建stripe订单
export function postCreateStripeOrder(orderId, data) {
  return http.post(`/checkout/create/intent/${orderId}`, data)
}
